export const ACTIVITY_STATS = {
  openrate: 0,
  sent: 0,
  uniqueviews: 0,
  totalreach: 0,
  uniqueclicks: 0,
  uniqueadclicks: 0,
  uniquevisits: 0,
  uniquevideolaunches: 0,
  uniquedocumentlaunches: 0,
  uniquedocumentdownloads: 0,
  uniquebizcardviews: 0,
  uniquebizcardscans: 0
};
